import React from "react";
import { Link } from "react-router-dom";
import { CCol, CContainer, CRow } from "@coreui/react";

export default function PublicFooter() {
  return (
    <footer className="public-core-footer">
      <CContainer fluid className="public-core-container">
        <CRow className="g-4 align-items-start">
          <CCol xl={5} lg={5}>
            <div className="public-core-footer__brand">
              <span className="public-core-eyebrow public-core-eyebrow--footer">Experts4Europe</span>
              <strong>Experts4Europe</strong>
              <p>
                Plattform für Jobs, Qualifikationen, Sprachtests, Wissenstests, Matching und vorbereitete
                Unterlagen für Recruiting- und Einwanderungswege in Europa.
              </p>
              <div className="public-core-footer__actions">
                <Link to="/login">Anmelden</Link>
                <Link to="/register">Registrieren</Link>
              </div>
            </div>
          </CCol>
          <CCol xl={2} md={4}>
            <div className="public-core-footer__group">
              <h3>Produkte</h3>
              <Link to="/stb/job-marketplace">Jobs</Link>
              <a href="#produkte">Produktübersicht</a>
              <a href="#wissenstests">Wissenstests</a>
              <a href="#matching">Scoring und Matching</a>
            </div>
          </CCol>
          <CCol xl={3} md={4}>
            <div className="public-core-footer__group">
              <h3>Zugang</h3>
              <Link to="/login">Anmelden</Link>
              <Link to="/register">Registrieren</Link>
              <a href="#fuer-bewerber">Für Bewerber</a>
              <a href="#fuer-arbeitgeber">Für Arbeitgeber</a>
            </div>
          </CCol>
          <CCol xl={2} md={4}>
            <div className="public-core-footer__group">
              <h3>Rechtliches</h3>
              <Link to="/impressum">Impressum</Link>
              <Link to="/agb">AGB</Link>
              <Link to="/datenschutz">Datenschutz</Link>
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </footer>
  );
}
